import * as React from "react";
import { renderKickOffState } from "../../../EventCard/RenderMethods/renderKickOffState";
import { renderScore } from "../../../EventCard/RenderMethods";
export const renderLiveDetailsMultiview = (event, componentPrefix, dict) => React.createElement(React.Fragment, null,
    React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__scores`, "data-uat": `div-ev-list-${componentPrefix}-scores` }, renderLiveScoreMultiview(event)),
    event.isInKickOffState && renderKickOffState(event, componentPrefix, dict));
const renderLiveScoreMultiview = (event) => {
    const score = { homeScore: event.score.homeScore, awayScore: event.score.awayScore };
    return renderScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard);
};
//# sourceMappingURL=renderLiveDetailsMultiview.js.map